import { Configuration, LogLevel, PublicClientApplication } from "@azure/msal-browser";

export const msalConfig: Configuration = {
  auth: {
    clientId: import.meta.env.VITE_AZURE_CLIENT_ID || "",
    authority: import.meta.env.VITE_AZURE_AUTHORITY
      || `https://login.microsoftonline.com/${import.meta.env.VITE_AZURE_TENANT_ID || ""}`,
    redirectUri: import.meta.env.VITE_AZURE_REDIRECT_URI || window.location.origin,
    postLogoutRedirectUri: `${import.meta.env.VITE_AZURE_REDIRECT_URI || window.location.origin}/signed-out`,
  },
  cache: {
    cacheLocation: "localStorage",
  },
  system: {
    loggerOptions: {
      logLevel: LogLevel.Warning,
    },
  },
};

export const loginRequest = {
  scopes: [import.meta.env.VITE_AZURE_API_SCOPE || ""],
};

// Persist the user's login hint in a cookie so loginRedirect can skip
// the account picker on subsequent app launches. Cookies on localhost
// are shared across ports, unlike localStorage which is origin-scoped.
export function getLoginHint(): string | undefined {
  const match = document.cookie.match(/(?:^|;\s*)msal_login_hint=([^;]*)/);
  return match ? decodeURIComponent(match[1]) : undefined;
}

function saveLoginHint(username: string): void {
  document.cookie = `msal_login_hint=${encodeURIComponent(username)}; path=/; max-age=31536000; SameSite=Lax`;
}

// Single shared MSAL instance used by all modules
export const msalInstance = new PublicClientApplication(msalConfig);

// Initialize MSAL and handle redirect responses; resolves before the
// React app renders (awaited in index.tsx).
export const msalInitPromise = msalInstance
  .initialize()
  .then(() => msalInstance.handleRedirectPromise())
  .then((response) => {
    if (response?.account) {
      msalInstance.setActiveAccount(response.account);
      if (response.account.username) saveLoginHint(response.account.username);
      return;
    }

    const accounts = msalInstance.getAllAccounts();
    if (accounts.length > 0) {
      msalInstance.setActiveAccount(accounts[0]);
      if (accounts[0].username) saveLoginHint(accounts[0].username);
    }
  })
  .catch((error) => {
    console.error("MSAL initialization failed:", error);
  });
